import { render, staticRenderFns } from "./global-breadcrumbs.vue?vue&type=template&id=02b5ef15"
import script from "./global-breadcrumbs.vue?vue&type=script&lang=js"
export * from "./global-breadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./global-breadcrumbs.vue?vue&type=style&index=0&id=02b5ef15&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports